"use client";

import { c as _c } from "react/compiler-runtime";
import { useAutoApplyUrlPromo } from "@/hooks/useAutoApplyUrlPromo";
import { useAutoEstimateShipping } from "@/hooks/useAutoEstimateShipping";
import { useOneClickReorderFlow } from "@/hooks/useOneClickReorderFlow";
import { CartSidebarContent } from "./CartSidebarContent";
interface Props {
  trustSignalsSlot?: React.ReactNode;
  optionalAddOnsSlot?: React.ReactNode;
}

/** The cart sidebar on non-checkout routes, where the site-only hooks run. */
export function CartSidebarSite(props) {
  const $ = _c(3);
  useAutoEstimateShipping();
  useAutoApplyUrlPromo();
  const reorderStatus = useOneClickReorderFlow();
  let t0;
  if ($[0] !== props || $[1] !== reorderStatus) {
    t0 = <CartSidebarContent {...props} reorderStatus={reorderStatus} />;
    $[0] = props;
    $[1] = reorderStatus;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}